import { useState, useEffect, useCallback } from "react";

interface WorldTimeResponse {
  datetime: string;
  timezone: string;
  utc_offset: string;
}

export const useBogotaTime = () => {
  const [currentTime, setCurrentTime] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTime = useCallback(async () => {
    try {
      const response = await fetch('https://worldtimeapi.org/api/timezone/America/Bogota');
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      const data: WorldTimeResponse = await response.json();
      
      // Parse the datetime and format it nicely
      const date = new Date(data.datetime);
      const timeString = date.toLocaleTimeString('es-CO', {
        hour12: true,
        hour: 'numeric',
        minute: '2-digit',
        timeZone: 'America/Bogota'
      });
      
      setCurrentTime(timeString);
      setError(null);
    } catch (err) {
      console.error('Error fetching Bogotá time:', err);
      setError(err instanceof Error ? err.message : 'Error desconocido');
      // Fallback to local time formatted for Colombia
      const fallbackTime = new Date().toLocaleTimeString('es-CO', {
        hour12: true,
        hour: 'numeric',
        minute: '2-digit'
      });
      setCurrentTime(fallbackTime);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    // Fetch immediately
    fetchTime();
    
    // Update every minute
    const interval = setInterval(fetchTime, 60000);
    
    return () => clearInterval(interval);
  }, [fetchTime]);

  return {
    currentTime,
    isLoading,
    error,
    refreshTime: fetchTime
  };
};